
import axios from 'axios'
import { mapGetters } from 'vuex'
import sortby from 'lodash.sortby'
import DashboardSidebarDesktop from '../components/dashboard/DashboardSidebarDesktop'
import DashboardMenuTop from '../components/dashboard/DashboardMenuTop'
import DashboardMenuMobile from '../components/dashboard/DashboardMenuMobile'
import gtm from '../assets/js/gtm'
import SaleBanner from '../components/dashboard/SaleBanner'
import MusicLimitReachedModal from '../components/dashboard/MusicLimitReachedModal'
import MusicPlayer from '@/components/jukebox/MusicPlayer'
import AppStreamerAwardsAwardModal from '~/components/molecules/AppStreamerAwardsAwardModal'

export default {
  name: 'LayoutDashboard',
  components: {
    MusicLimitReachedModal,
    DashboardMenuMobile,
    DashboardMenuTop,
    DashboardSidebarDesktop,
    MusicPlayer,
    SaleBanner,
    AppStreamerAwardsAwardModal,
    TheDebugBar: () => {
      if (process.env.NODE_ENV === 'development') {
        return import('../components/molecules/AppDebugBar.vue')
      }

      return {}
    }
  },
  data () {
    return {
      mobileMenu: false,
      menuCollapsed: false,
      isPluginWarningHidden: true,
      lastAward: {}
    }
  },
  head () {
    if (process.env.NODE_ENV === 'development') {
      return {}
    }

    return {
      script: [
        {
          id: 'ze-snippet',
          hid: 'stripe',
          src: 'https://static.zdassets.com/ekr/snippet.js?key=93b2f15c-501d-435d-aa98-72a81fffc4fe'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      showJukebox: 'jukebox/isActive',
      isSidebarOpen: 'sidebar/isOpen',
      showSaleBanner: 'salebanner/getVisible'
    }),
    pluginWarningStyle () {
      // eslint-disable-next-line max-len
      if (['dashboard', 'dashboard-statistics', 'dashboard-all-overlays', 'dashboard-my-subscription', 'dashboard-account-settings-my-account'].includes(this.$route.name)) {
        return 'left: 64px;'
      }

      return this.$route.name !== 'dashboard' && this.isSidebarOpen ? 'left: 306px;' : 'left: 64px;'
    }
  },
  watch: {
    showSaleBanner (newValue) {
      if (newValue) {
        document.body.classList.add('has-sale-banner')
      } else {
        document.body.classList.remove('has-sale-banner')
      }
    }
  },
  created () {
    // redirect the user to getting-started if setup is not completed
    if (this.$auth.user && !this.$auth.user.setup_completed) {
      this.$router.push({ name: 'dashboard-getting-started' })
    }
  },
  async mounted () {
    window.zESettings = {
      webWidget: {
        color: { theme: '#4a4dd6' },
        chat: {
          title: {
            '*': 'OWN3D.Pro'
          }
        }
      }
    }

    gtm()

    if (window.localStorage) {
      this.isPluginWarningHidden = !!window.localStorage.getItem('isPluginWarningHidden')
    }

    // TODO: use userAchievements composable after migrating to nuxt 3
    const fetchChannels = async (url, prevPagesData) => {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: this.$auth.strategy.token.get()
        }
      })

      const allData = [...data.data, ...prevPagesData]

      if (!data.next_page_url) {
        return allData
      }

      return fetchChannels(data.next_page_url, allData)
    }
    const channels = await fetchChannels('https://achievements.ingress.hel1.k8s.stream.tv/api/v1/channels?cached', [])

    const myChannel = channels.find(c => c.self === true)

    if (!myChannel) {
      return
    }

    const { data: channelInfos } = await axios.get('https://achievements.ingress.hel1.k8s.stream.tv/api/v1/channels/' + myChannel.id + '?with_awards=1&cached', {
      headers: {
        Authorization: this.$auth.strategy.token.get()
      }
    })

    const unlockedAwards = channelInfos.awards.filter(a => a.unlocked_at !== null)

    if (unlockedAwards.length) {
      const sortedAwards = sortby(unlockedAwards, 'unlocked_at')
      const lastAward = sortedAwards.length ? sortedAwards[sortedAwards.length - 1] : null

      let lastShownAward = null

      if (window.localStorage) {
        lastShownAward = parseInt(window.localStorage.getItem('lastShownAward'))
      }

      if (lastShownAward !== lastAward.id) {
        if (window.localStorage) {
          lastShownAward = window.localStorage.setItem('lastShownAward', lastAward.id)
        }
        this.lastAward = lastAward
      }
    }
  },
  methods: {
    returnToMainUser () {
      this.$axios.post('v1/users/acting-as/', { user_id: null }).then(() => {
        window.location = this.$router.resolve({ name: 'dashboard' }).href
      })
    },
    hidePluginWarning () {
      this.isPluginWarningHidden = true

      if (window.localStorage) {
        window.localStorage.setItem('isPluginWarningHidden', 1)
      }
    },
    showPluginWarning () {
      this.isPluginWarningHidden = false

      if (window.localStorage) {
        window.localStorage.removeItem('isPluginWarningHidden')
      }
    },
    getShopUrlForAwardId (awardId) {
      const shopBaseUrl = 'https://twitch.achievements.tv/pages/redeem-awards'

      return shopBaseUrl + '?award_id=' + awardId + '#access_token=' + this.$auth.strategy.token.get().replace('Bearer ', '') + '&token_type=Bearer'
    }
  }
}
